/* eslint-disable react/no-unused-prop-types */
import { useMemo } from 'react';
import classNames from 'classnames';

import { IMAGES } from './config';

type NotificationBasicProps = {
	readonly className?: string;
	readonly content: React.JSX.Element | string;
	readonly title: string;
	readonly type: 'success' | 'warning' | 'error' | 'custom';
};

type NotificationCustomProps = {
	readonly className?: string;
	readonly description: React.JSX.Element | string;
	readonly title: string;
	readonly image: keyof typeof IMAGES;
};

const classNameComponente = 'c-pin-notification';

export const NotificationBasic = ({ className, title, content }: NotificationBasicProps) => {
	const notificationClassName = useMemo(() => classNames(className, classNameComponente), [className]);

	return (
		<div className={notificationClassName}>
			<h2 className={`[ ${classNameComponente}__tit ] [ u-mt-16 ]`}>{title}</h2>
			<div className="u-mt-32 u-flow-16">{content}</div>
		</div>
	);
};

export const NotificationCustom = ({ className, title, description, image }: NotificationCustomProps) => {
	const notificationClassName = useMemo(() => classNames(className, classNameComponente), [className]);
	const FinalIcon = IMAGES[image];

	return (
		<div className={notificationClassName}>
			<FinalIcon className={`${classNameComponente}__img`} />
			<h2 className={`[ ${classNameComponente}__tit ] [ u-mt-16 ]`}>{title}</h2>
			<div className="u-mt-32 u-flow-16">{description}</div>
		</div>
	);
};
